(ns bp-libs.design-system.components.modal
  "Namespace modal"
  (:require [bp-libs.design-system.components.animations :refer [rotating-spinner]]
            [bp-libs.design-system.components.buttons :refer [Button]]))

(defn Modal
  "Component that displays a configurable Modal"
  {:storybook {:header  {:name         "Header"
                         :control      {:type "text"}
                         :defaultValue "My Header"}
               :message {:name         "Message"
                         :control      {:type "text"}
                         :defaultValue "My message"}}}
  [{:keys [header message button spinner?]}]
  [:div {:class "fixed top-0 left-0 w-full h-full bg-black text-white z-50 flex flex-col justify-center items-center"}
   [:div {:class "flex-col items-center justify-center flex max-w-3xl"}
    [:h2 {:class "mb-8 text-5xl font-bold leading-[3.75rem] tracking-tight"} header]
    [:p {:class "mb-12 text-3xl font-medium leading-9 tracking-tight text-center"} message]
    (cond
      spinner? [rotating-spinner]
      button   [Button {:react-ref     (:react-ref button)
                        :on-key-down   (:on-key-down button)
                        :extra-classes ["py-3.5 px-7 outline-none text-lg rounded-full"]
                        :on-click      (:on-click button)}
                (:title button)])]])

